import React from "react";
import { Trans } from "@lingui/macro";
import {
  BaseCard,
  BaseCardBody,
  BaseCardFooter,
  BaseCardSanityImage,
  BaseCardTitle,
  Button
} from "@silversea-ssc/ui-components-react";

import * as styles from "./CruiseSuiteCard.module.scss";
import PriceFromBox from "../PriceFromBox/PriceFromBox";
import PricePromos from "../PriceFromBox/PricePromos";
import { CruisePriceFrom } from "types/api/suite_price.d";
import { LocationSpecificOffer } from "components/useLocationSpecificOffers/types";
import { BaseCardSanityImageProps } from ".yalc/@silversea-ssc/ui-components-react/dist/BaseCard/BaseCard";

export interface CruiseSuiteCardProps {
  title?: string;
  description?: string;
  image?: BaseCardSanityImageProps["image"];
  raqCTAUrl?: string;
  price: CruisePriceFrom;
  offers: LocationSpecificOffer[];
  detailsOnClick: () => void;
  trackingName: string;
}

const CruiseSuiteCard: React.FC<CruiseSuiteCardProps> = ({
  title,
  description,
  image,
  raqCTAUrl,
  price,
  detailsOnClick,
  offers,
  trackingName
}) => {
  return (
    <BaseCard
      background="neutral05"
      textAlign="center"
      trackingName={trackingName}
    >
      <BaseCardSanityImage image={image} ratio="card" />
      <BaseCardTitle>{title}</BaseCardTitle>
      <BaseCardBody>
        {description && (
          <div className={styles.description}>
            <Trans>Up to</Trans> {description}
          </div>
        )}
        <PriceFromBox price={price}>
          <PricePromos offers={offers} variant="list" />
        </PriceFromBox>
      </BaseCardBody>
      <BaseCardFooter className={styles.footer}>
        {raqCTAUrl && (
          <Button
            variant="secondary"
            href={raqCTAUrl}
            data-content-piece="request_a_quote"
          >
            <Trans>Request a Quote</Trans>
          </Button>
        )}
        <Button
          variant="primary"
          renderAs="button"
          onClick={detailsOnClick}
          iconName="arrow-right"
          data-content-piece="details"
        >
          <Trans>Details</Trans>
        </Button>
      </BaseCardFooter>
    </BaseCard>
  );
};

export default CruiseSuiteCard;
